import {
  SHIFT_CONFLICT_FAIL,
  SHIFT_CONFLICT_REQUEST,
  SHIFT_CONFLICT_SUCCESS,
  BULK_SHIFT_ASSIGN_FAIL,
  BULK_SHIFT_ASSIGN_REQUEST,
  BULK_SHIFT_ASSIGN_SUCCESS,
} from "../../types/admin/shiftTypes";

export const shiftConflictReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHIFT_CONFLICT_REQUEST:
      return {
        ...state,
        shiftConflictLoading: true,
      };
    case SHIFT_CONFLICT_SUCCESS:
      return {
        ...state,
        shiftConflictLoading: false,
        shiftConflictData: payload,
        error: "",
      };
    case SHIFT_CONFLICT_FAIL:
      return {
        ...state,
        shiftConflictLoading: false,
        error: payload,
        getIdScreenData: [],
      };
    default:
      return state;
  }
};
export const bulkShiftAssignReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case BULK_SHIFT_ASSIGN_REQUEST:
      return {
        ...state,
        bulkShiftAssignLoading: true,
      };
    case BULK_SHIFT_ASSIGN_SUCCESS:
      return {
        ...state,
        bulkShiftAssignLoading: false,
        bulkShiftAssignData: payload,
        error: "",
      };
    case BULK_SHIFT_ASSIGN_FAIL:
      return {
        ...state,
        bulkShiftAssignLoading: false,
        error: payload,
        getIdScreenData: [],
      };
    default:
      return state;
  }
};
